import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { AuthPopupModel } from './AuthPopup.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';

const customCss: string = '';

@Component({
    selector: 'app-AuthPopup',
    templateUrl: './AuthPopup.component.html'
})
export class AuthPopupComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('txtAuthPassword', { static: false }) txtAuthPassword: PasswordComponent;
    @ViewChild('btnAuthOk', { static: false }) btnAuthOk: ButtonComponent;
    @ViewChild('btnAuthCancel', { static: false }) btnAuthCancel: ButtonComponent;
    @Input('params') params: any;
    @Input('activeModal') activeModal: NgbActiveModal;
    skeletonContentLoaded = false;
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.revalidateBasicField('txtAuthPassword'),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new AuthPopupModel();
        this.componentCode = 'AuthPopup';
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.setDependencies();
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'AuthPopup';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
        return this.additionalInfo;
    }
    getFieldValue() {
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.value = new AuthPopupModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'AuthPopup'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'AuthPopup_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('AuthPopup_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.onFormLoad();
            this.checkForHTabOverFlow();
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new AuthPopupModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async btnAuthOk_click() {
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        document.getElementById('errMsgDiv3').innerHTML = "";

        if (errorCount == 0) {
            inputMap.clear();
            inputMap.set('Body.password', this.txtAuthPassword.getFieldValue());
            this.services.http.fetchApi('/auth/authenticate', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == 0) {

                        this.services.http.oeLoggedIn = true;
                        this.activeModal.close('ok');
                    } else {
                        this.services.http.oeLoggedIn = false;
                        //document.getElementById('errMsgDiv3').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv3') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        if (err['ErrorElementPath'] == 'password') {
                            this.txtAuthPassword.setError(err['ErrorDescription']);
                        }
                    }
                    document.getElementById('errMsgDiv3').innerHTML = this.transalte('ErrorCodes.SystemDown');
                }
            );
        }
    }
    async btnAuthCancel_click() {
        this.activeModal.close('cancel');
    }

    transalte(text) {
        return this.services.translate.instant(text);
    }
    fieldDependencies = {
    }

}